import React from "react";
import propTypes from "prop-types";
import { connect } from "react-redux";

import Link from "../Link/Link";

import icons from "../../data/icons";
import panelData from "../../data/panel.json";

import "./Panel.css";
const Panel = props => {
  const panel = panelData[props.panelID];
  let isMobile = window.innerWidth <= 760;
  return (
    <article
      className={`panel ${isMobile || !props.navigationWait ? "show" : "hide"}`}
    >
      {panel.pretitle && (
        <h1 className={"panel__pretitle"}>{panel.pretitle}</h1>
      )}
      {panel.title && <h2 className={"panel__title"}>{panel.title}</h2>}
      <section className={"panel__inner"}>
        {panel.text.map((item, pos) => {
          if (item.type === "para") {
            return (
              <p className={"panel__para"} key={item.id}>
                {item.content}
              </p>
            );
          }
          if (item.type === "list") {
            return (
              <ul
                className={"panel__list"}
                key={item.id || panel.id + "ul" + pos}
              >
                {item.content.map((bullet, bpos) => {
                  return (
                    <li key={bullet.id} className={"panel__bullet"}>
                      {bullet.text}
                    </li>
                  );
                })}
              </ul>
            );
          }
          return null;
        })}

        <div className={"panel__calloutArea"}>
          {panel.callouts &&
            panel.callouts.map(callout => (
              <div className={"panel__callout"} key={callout.id}>
                {callout.items.map(item => (
                  <div className={"panel__calloutItem"} key={item.id}>
                    <span className={"callout__pre"}>{item.pre}</span>
                    <div>
                      <span className={"callout__metric"}>{item.metric}</span>
                      <span className={"callout__unit"}>{item.unit}</span>
                    </div>
                    <span className={"callout__post"}>{item.post}</span>
                  </div>
                ))}
              </div>
            ))}
        </div>
        {panel.moreInfo && panel.moreInfo.map(moreInfo => (
          <Link
            className={"panel__moreInfo"}
            url={moreInfo.href}
            target={"__blank"}
            rel={"external"}
          >
            {moreInfo.text ? moreInfo.text : "MORE INFO"}
          </Link>
        ))}
        {panel.relatedMedia && (
          <div className={"panel__relatedMedia"}>
            <span className={"relatedMedia__title"}>Related Media</span>
            {panel.relatedMedia.map(media => (
              <div key={media.id}>
                <a
                  href={media.link}
                  target={"__blank"}
                  rel={"external noopener"}
                  className={"relatedMedia__link"}
                >
                  <p className={"relatedMedia__area"}>
                    {media.icon && (
                      <img
                        className={"relatedMedia__icon"}
                        alt={`${media.icon} icon`}
                        src={icons[media.icon].svg}
                      />
                    )}
                    <span className={"relatedMedia__label"}>{media.label}</span>
                    <div className={"relatedMedia__linkArea"}>
                      <span className={"relatedMedia__open"}>OPEN</span>
                      <span className={"relatedMedia__arrow"}>→</span>
                    </div>
                  </p>
                </a>
              </div>
            ))}
          </div>
        )}
      </section>
    </article>
  );
};

function mapStateToProps(state) {
  return {
    currentGroup: state.navigation.currentGroup,
    navigationWait: state.navigation.navigationWait
  };
}

Panel.propTypes = {
  currentGroup: propTypes.string.isRequired,
  navigationWait: propTypes.bool.isRequired
};

export default connect(mapStateToProps)(Panel);
